import { useTranslation } from "react-i18next";
import ListPage from "../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";
import { useState } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import InputText from "../../../components/Forms/Element/InputText";
import StatusFilterSelect, { DEFAULT_STATUS, buildStatusFilter } from "../../../components/Common/Filter/StatusFilterSelect";
import { SearchOperation } from "../../../../utils/ApiUtils";

const CardFlagList = () => {

    const { t } = useTranslation();
    const [nameFilter, setNameFilter] = useState('');
    // A grade já abre só com ativos, então o select nasce em Ativo: o campo mostra o recorte
    // que está valendo em vez de parecer vazio.
    const [statusFilter, setStatusFilter] = useState(DEFAULT_STATUS);
    const [filters, setFilters] = useState([]);

    const handleSearch = () => {
        const activeFilters = [];

        if (nameFilter && nameFilter.trim()) {
            activeFilters.push({
                field: "name",
                value: nameFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }

        activeFilters.push(buildStatusFilter(statusFilter));

        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setNameFilter('');
        setStatusFilter(DEFAULT_STATUS);
        setFilters([]);
    };

    return (
        <>
            <PageTitle activeMenu={t("card_flags")} motherMenu={t("main")} />

            <FilterAccordion
                title="filters"
                onSearch={handleSearch}
                onClear={handleClearFilters}
                centerButtons={false}
            >
                <Row className="g-2 align-items-end">
                    <Col lg={5} md={6}>
                        <FormLabel>{t('name')}</FormLabel>
                        <InputText
                            value={nameFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                            placeholder={t('name')}
                        />
                    </Col>
                    <Col lg={4} md={6}>
                        <StatusFilterSelect value={statusFilter} onChange={setStatusFilter} />
                    </Col>
                </Row>
            </FilterAccordion>

            <ListPage
                showPageTitle={false}
                activeMenu={t("card_flags")}
                motherMenu={t("main")}
                path={Api.main.card_flag}
                route={MenuConfig.main.card_flag.route}
                columns={Columns}
                filters={filters}
                hideInactiveToggle
            />
        </>
    );
}

export default CardFlagList;